import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import RectangleSkeletons from "../RectangleSkeletons";
import { showPhoneStatusColors } from "../../utils/helpers";
import MobileAppStatusIcon from "../MobileAppStatusIcon";
import MccLogo from "../MccLogo";

const AlertDialog = ({
  submitID,
  data,
  openModal,
  closeModal,
  resetModal = false,
  resetModalHandler,
  formSubmitFunction,
  submitText = "Yes",
  maxWidth = "xs",
  children,
  padding = "8px",
  isLoading = false,
  moveFileDialog = false,
  caseSummary = false,
  color = "primary",
  cancelColor = "#000",
  disabled = false,
  contentPadding,
  titlePadding,
  titlePaddingTop = "16px",
  contentPaddingTop = "16px !important",
  actionsPaddingTop,
  cancelText = "Cancel",
  closeOverlay = true,
  showCancelIcon = false,
  showCancelConfirmationModalHandler,
  showConfirmationOnCancel = false,
  loadingConsent = false,
  fontWeight = "500 !important",
  height,
  borderRadius = "4px",
  dialogActions = true,
  cancelIcon = <CloseIcon />,
  titleFontSize = "20px",
  showAppIcon = false,
  appStatus,
  openAppModalHandler,
  ever_pain_logged,
  // enrollment_status,
  showCancelIconButton = false,
  cancelIconText,
  marginBottom,
  cancelStartIcon,
  cancelButtonTextTransform,
  pinnedText = false,
  pinnedTextComponent,
  disabledText = false,
  textTransform,
  footerTitle = false,
  iconPadding = "4px",
  showCancelButton = true,
  footerText,
  alignItems = "flex-start",
  showCustomDialogAction = false,
  credentialsSent,
  enrolments,
  enrollment_status,
  creation_flow,
  ever_logged_in,
  ever_logged_pain,
  last_reading,
}) => {
  //   const handleClickOpen = () => {
  //     setOpen(true);
  //   };

  //   const handleClose = () => {
  //     setOpen(false);
  //   };

  return (
    <Dialog
      open={openModal}
      maxWidth={maxWidth}
      fullWidth={true}
      onClose={closeOverlay ? closeModal : null}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        sx: {
          borderRadius: borderRadius,
          width: "100%",
          maxWidth: `${maxWidth} !important`,
          height: height && height,
          overflow: "visible",
        },
      }}
    >
      <Box
        display="flex"
        justifyContent="center"
        sx={{
          marginTop: "-40px",
          marginBottom: "0",
        }}
      >
        <MccLogo variant="dialog" size={80} />
      </Box>
      {loadingConsent ? (
        <Stack padding="18px">
          <RectangleSkeletons height={20} totalRows={1} width="50%" />
        </Stack>
      ) : (
        <DialogTitle
          sx={{
            padding: titlePadding && titlePadding,
            paddingBottom: moveFileDialog ? "32px" : "0 !important",
            paddingTop: titlePaddingTop === "16px" ? "8px" : titlePaddingTop,
          }}
          id="alert-dialog-title"
          fontSize="2rem"
        >
          <Box
            display="flex"
            alignItems={alignItems}
            justifyContent="space-between"
          >
            <Stack lineHeight="24px" fontWeight={fontWeight}>
              {showAppIcon ? (
                <Box display="flex" alignItems="center" gap="8px">
                  {/* <IconButton onClick={openAppModalHandler}>
                    {showPhoneStatusColors(
                      appStatus,
                      ever_pain_logged,
                      enrollment_status,
                      credentialsSent
                    )}
                  </IconButton> */}
                  <MobileAppStatusIcon
                    enrolments={enrolments}
                    enrollment_status={enrollment_status}
                    creation_flow={creation_flow}
                    ever_logged_in={ever_logged_in}
                    ever_logged_pain={ever_logged_pain}
                    last_reading={last_reading}
                  />
                  <Typography
                    variant="h5"
                    fontSize={titleFontSize}
                    fontWeight={fontWeight}
                  >
                    {data?.title}
                  </Typography>
                </Box>
              ) : (
                <Typography
                  sx={{ display: "flex", alignItems: "center", gap: "8px" }}
                  variant="h5"
                  fontSize={titleFontSize}
                  fontWeight={fontWeight}
                >
                  {data?.title}
                </Typography>
              )}

              {data?.lightText && (
                <Typography
                  component="span"
                  style={{ fontWeight: "400 !important" }}
                  color="secondary"
                >
                  {data?.lightText}
                </Typography>
              )}
            </Stack>
            {showCancelIcon &&
              (showCancelIconButton ? (
                <Button
                  variant="text"
                  disabled={disabledText}
                  onClick={closeModal}
                  startIcon={cancelStartIcon}
                  sx={{ textTransform: cancelButtonTextTransform }}
                >
                  {cancelIconText}
                </Button>
              ) : (
                <IconButton sx={{ padding: iconPadding }} onClick={closeModal}>
                  {cancelIcon}
                </IconButton>
              ))}
          </Box>
        </DialogTitle>
      )}
      <DialogContent
        sx={{
          padding: contentPadding && contentPadding,
          paddingTop: contentPaddingTop,
          marginBottom: marginBottom,
        }}
      >
        {data?.subtitle ? (
          <DialogContentText
            id="alert-dialog-description"
            color="rgba(0, 0, 0, 0.87)"
          >
            {data?.subtitle}
          </DialogContentText>
        ) : (
          children
        )}
      </DialogContent>
      {dialogActions && (
        <DialogActions
          sx={{
            padding: padding,
            paddingTop: actionsPaddingTop,
            justifyContent: pinnedText ? "space-between" : "flex-end",
          }}
        >
          {pinnedText && pinnedTextComponent}
          <Box
            display="flex"
            alignItems="center"
            gap="8px"
            width={showCustomDialogAction ? "100%" : "auto"}
          >
            {showCancelButton && (
              <Button
                variant={showCustomDialogAction ? "outlined" : "text"}
                sx={{
                  border: showCustomDialogAction
                    ? `1px solid ${cancelColor}`
                    : "",
                  color: cancelColor,
                  textTransform: textTransform,
                  flex: showCustomDialogAction ? 1 : "initial",
                  width: showCustomDialogAction ? "100%" : "auto",
                  "&:hover": {
                    border:
                      showCustomDialogAction && `1px solid ${cancelColor}`,
                  },
                }}
                onClick={
                  showConfirmationOnCancel
                    ? showCancelConfirmationModalHandler
                    : resetModal
                    ? resetModalHandler
                    : closeModal
                }
              >
                {cancelText}
              </Button>
            )}
            <LoadingButton
              id={submitID}
              disabled={disabled}
              loading={isLoading}
              variant="contained"
              onClick={formSubmitFunction}
              color={color}
              sx={{
                textTransform,
                flex: showCustomDialogAction ? 1 : "initial",
                width: showCustomDialogAction ? "100%" : "auto",
              }}
            >
              {submitText}
            </LoadingButton>
          </Box>
        </DialogActions>
      )}

      {footerTitle && (
        <Box padding="0 24px 24px">
          <Box padding="6px 16px" bgcolor="#EFF6FF" borderRadius="4px">
            <Typography color="#11304F" variant="caption">
              {footerText}
            </Typography>
          </Box>
        </Box>
      )}
    </Dialog>
  );
};

export default AlertDialog;
